import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreateAssignmentSchema, UpdateAssignmentSchema } from '@app/models/users';
import Api from '@app/services/api';
/** Префикс ключа: по нему мутации инвалидируют оба среза - и «действующие», и «все». */
export const assignmentsQueryKey = (userId?: number) => ['assignments', userId];

export const useAssignmentsQuery = (userId?: number, activeOnly = true, offset = 0, limit = 20) =>
  useQuery({
    queryKey: [...assignmentsQueryKey(userId), activeOnly, offset, limit],
    queryFn: () =>
      Api.users.getAssignments({
        user_id: userId as number,
        offset,
        limit,
        is_active: activeOnly || undefined,
      }),
    enabled: !!userId,
  });

export const useRolesListQuery = () =>
  useQuery({
    queryKey: ['rolesList'],
    queryFn: () => Api.users.getRoles(),
    staleTime: 5 * 60 * 1000,
  });

export const useRuleAttributesQuery = () =>
  useQuery({
    queryKey: ['assignmentRuleAttributes'],
    queryFn: () => Api.users.getAssignmentRuleAttributes(),
    staleTime: Infinity,
  });

export const useCreateAssignmentMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAssignmentSchema) => Api.users.postAssignment(data),
    onSuccess: (res) => client.invalidateQueries(assignmentsQueryKey(res.user_id)),
  });
};

export const useUpdateAssignmentMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (vars: { uid: string; data: UpdateAssignmentSchema }) => Api.users.putAssignment(vars.uid, vars.data),
    onSuccess: (res) => client.invalidateQueries(assignmentsQueryKey(res.user_id)),
  });
};

export const useRevokeAssignmentMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (uid: string) => Api.users.revokeAssignment(uid),
    onSuccess: (res) => client.invalidateQueries(assignmentsQueryKey(res.user_id)),
  });
};
